import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Shared/Common/Icon';

import styled from 'styled-components';
import { rgba } from 'polished';

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 10px 15px;
    width: 100%;
    position: relative;
`;

const StyledArrow = styled.div`
    &.arrow-pointer{
        position: absolute;
        top: -10px;
        right: 35px;
        width: 25px;
        svg{
            fill: ${({ theme }) => theme.fixedWhite};
            color: ${({ theme }) => theme.fixedWhite};
            transform: rotateZ(-85deg);
        }
    }
`;

const StyledContent = styled.div`
    &.placeholder-content{
        display: flex;
        flex-direction: column;
        .text{
            font-size: 14px;
            color: ${({ theme }) => theme.fixedWhite};
            font-weight: 700;
        }
        .subtext{
            font-size: 12px;
            color: ${({ theme }) => rgba(theme.fixedWhite, 0.6)};
            font-weight: 400;
        }
    }
`;

const Placeholder = ({ title, subTitle = '' }) => (
    <Styled className="placeholder">
        <StyledArrow className="arrow-pointer">
            <Icon iconName="Arrow" />
        </StyledArrow>
        <StyledContent className="placeholder-content">
            <div className="text">
                {title}
            </div>
            <div className="subtext">
                {subTitle}
            </div>
        </StyledContent>
    </Styled>
);

Placeholder.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ])
};

export default Placeholder;
